<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div>
    <div class="scrollable-mode">
      <el-switch
        v-if="!allValueZero"
        v-model="scrollableMode"
        :disabled="columnChartData.traceData[0].x.length == 1"
        @change="handleScrollableMode"
        active-text="scroll chart">
      </el-switch>
    </div>
    <div class="view-by-column">View by {{this.type}}</div>
    <div ref="chart" class="wy-panel-column-chart" :id="chartId">
    </div>
    <div ref="hoverChart" id='hoverinfo'>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import WyChartModule from '../../../library/wy-chart-module.js';
import WyChartUtils from '../utils/wy-chart-util.js';
import WyPanelUtils from '../../../components/panel-views/utils/wy-panel-util.js';

export default Vue.extend({
  name: 'wy-panel-column-chart',
  props: ['chartId', 'columnChartData', 'tabBottomSection', 'type'],

  data() {
    return {
      module: this,
      scrollableMode: false,
      loading: false,
      tickformat: '%b %Y',
      allValueZero: true,
      localData: null,
      hasRegressionData: true
    }
  },
  methods: {
    handleDateChange(type){
      if(type == 'year'){
        this.tickformat = '%Y'
      } else if (type == 'quarter'){
        this.tickformat = '%b %d %Y'
      } else if (type == 'week'){
        this.tickformat = '%b %d %Y'
      } else if (type == 'day'){
        this.tickformat = '%b %d %Y'
      } else if (type == 'month'){
        this.tickformat = '%b %Y'
      }
    },
    handleScrollableMode() {
      this.buildChart('scrollable')
    },
    toggleLegend(legendsData) {
      let mapLagends = WyPanelUtils.mapLagends;
      this.localData = JSON.parse(JSON.stringify(this.columnChartData));
      let showTraceList = []
      this.hasRegressionData = true
      this.localData.traceData.forEach((traceData) => {
        legendsData.forEach(legendObj => {
          if(legendObj.toggle && mapLagends[traceData.key] == legendObj.legend && legendObj.legend != 'regression') {
            showTraceList.push(traceData)
          }
          if(!legendObj.toggle && legendObj.legend == 'regression') {
            this.hasRegressionData = false
          }
        })
      })
      this.localData.traceData = showTraceList;
      this.buildChart('legend');
    },
    buildTooltip(point, data) {
      //console.log('data', data);
      
      const pointX = point.bbox.x1;  
      const pointY = point.bbox.y1;
      const pointIndex = point.pointIndex;

      data.forEach((item) => {
        this.tabBottomSection.legendsData.forEach(legendObj => {
          if(item.marker && item.marker.color == legendObj.color) {
            item.legend = legendObj.legend
          }
        })
      })

      let localData = JSON.parse(JSON.stringify(data));
      let labels = [];

      localData.forEach(el => {
        labels.push(el.legend)
      });
      if(localData[localData.length - 1].key == 'regression'){
        labels[labels.length - 1] = 'regression'
      } 

      let colors = [];
      localData.forEach(el => {
        if(el.marker){
          colors.push(el.marker.color)
        }
      });

      let values = [];
      localData.forEach(el => {
        values.push(el.y[pointIndex]);
      });
      
      let sum = 0;
      let valuesWithoutRegresssion = [];
      for(let i = 0; i < labels.length; i++){
        if(labels[i] == 'regression'){
          valuesWithoutRegresssion = values.slice(0, i)
        }
        else {
          valuesWithoutRegresssion = values;
        }
      }
      valuesWithoutRegresssion.forEach(num => sum += num);
    
      let pointDate = "";
      if(data[0].z && data[0].z.length > 0) {
        pointDate = data[0].z[pointIndex];
      }
      else {
        if(this.type == 'day') {
          pointDate = moment(data[0].x[pointIndex]).format("MMM DD YYYY");
        }
        else {
          pointDate = data[0].x[pointIndex];
        }
      }

      const labelHtml = labels.map((p, idx) => {
        return `<div style="display:flex;">
                    <div class="${p == 'regression'? 'regression-marker':'dx-tooltip-pipe'}" style="background-color: ${colors[idx]}">
                    </div>
                    <div class="dx-tooltip-label" style="font-weight: 400; display: flex; flex-direction: column">
                        <div class="tooltip-legendtext-label">${p == '--'? p = 'Unknown': p}</div>
                      <div class="tooltip-legendtext-num">${values[idx] !== null? values[idx].toFixed(1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","): '0.0'} ${p === 'regression'? ' ': valuesWithoutRegresssion[idx] == 0? "(0.0%)" :'(' + ((valuesWithoutRegresssion[idx]/sum) * 100).toFixed(1) + '%)'}</div>
                    </div>
                  </div>`;
      }).join('');

      const html = ` <div class="dx-tooltip tooltip-bg" style="left: ${pointX + 15}px; top:${pointY - 50}px">
                        <div style="pointer-events: none;">
                            <div class="tooltip-legendtitletext" style="text-align:center">${pointDate}</div>
                        </div>
                        <div>
                            ${labelHtml}
                        </div>
                    </div>`;
      return html;
    },
    buildChart(mode) {
      setTimeout(()=>{
        const wyChart = new WyChartModule();
        if(!mode) {
          this.localData = JSON.parse(JSON.stringify(this.columnChartData));

          this.hasRegressionData = true;
        }
        let yTotal = [];
        this.localData.traceData[0].y.forEach((item)=>{
          yTotal.push(item)
        });
        this.localData.traceData.forEach((item, index) => {
          if(index > 0) {
            item.y.forEach((yValue, valIndex) => {
              yTotal[valIndex] = yTotal[valIndex] + yValue
            })
          }
        })
        this.allValueZero = true;
        yTotal.forEach(yVal => {
          if(yVal != 0) {
            this.allValueZero = false;
          }
        })
        const median = wyChart.prepareRegressionDataByTrace({x: this.localData.traceData[0].x, y: yTotal}, {});
        let traceRegression = {
          name: '',
          type: 'scatter',
          mode: "lines",
          key: 'regression',
          x: median.regressionData.xValues,
          y: median.regressionData.yValues,
          showlegend: false,
          fill: 'none',
          line: {
            dash: 'dot',
            color: '#0A0B37',
            width: 1.5
          },          
        };
        let layout = {
          barmode: 'stack',
          // title: {
          //   text: this.type,
          //   font: {
          //     size: 12
          //   },
          //   y:  0.99,
          //   x: 0.96
          // },
          margin: { l: 20, r: 50, t: 30, b: 10, pad: 10},
          autosize: true,
          height: 300,
          hovermode: 'x',
          bargap: 0.2,
          dragmode: false,
    
          showlegend: false,      
          xaxis:  {
            autorange: true,
            fixedrange: true,
            showgrid: false,
            // automargin: true,
            showline: true,
            tickformat: this.tickformat,
            linecolor: 'transparent',
            tickangle: 0,
            rangeslider: {autorange: true}
          },
          yaxis: {
            name: 'y2',
            title: '',
            rangemode: 'nonnegative',
            // titlefont: {color: '#000'},
            // tickfont: {color: '#000'},
            fixedrange: true,
            side: 'right',
            // position: 0.15
          },
          yaxis2: {
            name: 'y1',
            title: '',
            titlefont: {color: 'transparent'},
            tickfont: {color: 'transparent'},
            anchor: 'free',
            overlaying: 'y',
            side: 'left',
            position: 0,
            rangemode: 'nonnegative',
            autosize: true,
            fixedrange: true
          }
        }
        if(this.type) {
          this.handleDateChange(this.type)
        }

        let xLength = this.localData.traceData[0].x.length
        if(!mode) {
          if(xLength < 20 || this.allValueZero) {
            this.scrollableMode = false;
          }
          else {
            this.scrollableMode = true;
          }
        }
        if(xLength > 1 && xLength < 5) {
          layout.xaxis.nticks = xLength + 1;
          if(this.type == 'year') {
            layout.xaxis.tickformat = null;
          }
          // if(this.type == 'week') {
          //   layout.xaxis.tickmode = 'array';
          //   layout.xaxis.tickvals = [];
          //   this.localData.traceData[0].x.forEach(traceX => {
          //     layout.xaxis.tickvals.push(traceX)
          //   })
          //   // layout.xaxis.tickvals = [trace.x[0], trace.x[Math.round((xLength - 1)/2)], trace.x[xLength - 1]]
          //   layout.xaxis.nticks = xLength;
          // }
        }
        else {
          if(xLength == 1) {
            layout.xaxis.nticks = 2;
            layout.xaxis.tickformat = null;
            this.localData.traceData.forEach(trace=>{
              // if(!this.scrollableMode){
              //   trace.width = 0.4
              // }
              // else {
              //   trace.width = 2
              // }
              trace.width = 0.4
            })
          }
          else {
            this.localData.traceData.forEach(trace=>{
              // if(xLength >= 5 && xLength < 10) {
              //   layout.xaxis.nticks = 5;
              // }
              // if(xLength >= 10) {
                if(!this.scrollableMode){
                  layout.xaxis.tickmode = 'array';
                  layout.xaxis.tickvals = [trace.x[0], trace.x[Math.round((xLength - 1)/2)], trace.x[xLength - 1]]
                }
                layout.xaxis.nticks = 3;
              // }
              layout.xaxis.tickformat = this.tickformat;
              trace.width = null;
              trace.thickness = 50
            })
          }
        }
        let config = {responsive: true, displayModeBar: false, scrollZoom: false, showTips: false};
        let data = [];
        this.localData.traceData.forEach(traceBar => {
          traceBar.yaxis = 'y1';
          data.push(traceBar);
        })
        traceRegression.yaxis = 'y1'
        if(this.hasRegressionData) {
          data.push(traceRegression);
        }
        
        
        // let xLength = this.lineChartData.xAxisData.length
        if(this.type == 'day') {
          WyChartUtils.scrollableChartSetLayoutByDay(this.localData.traceData[0].x, xLength, layout)
        }
        if(this.type == 'week') {
          WyChartUtils.scrollableChartSetLayoutByWeek(xLength, layout)
        }
        if(this.type == 'month') {
          WyChartUtils.scrollableChartSetLayoutByMonth(xLength, layout)
        }
        if(this.type == 'year') {
          WyChartUtils.scrollableChartSetLayoutByYear(xLength, layout)
        }

        if(!this.scrollableMode || xLength == 1) {
          layout.xaxis.autorange = true;
          layout.xaxis.automargin = true;
          layout.xaxis.rangeslider = null; 
        }
        else {
          layout.xaxis.autorange = false;
          layout.xaxis.automargin = null;
          layout.xaxis.rangeslider = {autorange: true, thickness: 0.1}
        }
        if(!mode || mode != 'legend') {
          // eslint-disable-next-line no-undef
          Plotly.newPlot(this.chartId, data, layout, config);
        }
        else {
          // eslint-disable-next-line no-undef
          Plotly.newPlot(this.chartId, data, this.$refs.chart.layout, this.$refs.chart.config);
        }
        
        this.$refs.chart.on('plotly_hover', (hoverData) => {   
          hoverData.event.preventDefault();
          hoverData.event.stopPropagation();
          try {
            if(this.$refs.hoverChart) {
              const toolTipHtml = this.buildTooltip(hoverData.points[0], this.$refs.chart.data);
              const gd = this.$refs.hoverChart;
              gd.style.display = "block";
              gd.innerHTML = toolTipHtml;
            }
          }
          catch(error) {
            console.error(error)
          }
        });

        this.$refs.chart.on('plotly_unhover', (data) => {
          try {
            data.points[0].xaxis._categories = this.localData.traceData[0].x;
            
            if(this.$refs.hoverChart){
              const gd = this.$refs.hoverChart;
              gd.innerHTML = '';
              gd.style.display = "none";
            }
          }
          catch(error) {
            console.error(error)
          }
        });
      }, 50)
    }
  },

  mounted(){
    this.buildChart();

    this.$root.$on(`fire-selected-date-change-events`, (type) => {
        this.handleDateChange(type)
      }
    )
  }
});
</script>

<style lang="scss">
    .tooltip-bg{
      box-shadow: 2px 1px 10px 1px rgba(199,199,199,0.76);
      border: none !important;
      width: fit-content !important;
      padding: 20px !important;
    }
    .tooltip-bg::before {
      content:"";
    }

    .tooltip-legendtext-label{
      font-weight: 400 !important;
      color: #4B5158 !important;
      margin-bottom: 5px;
      font-size: 14.22px !important;
    }
    .tooltip-legendtext-num{
      font-weight: 500 !important;
      font-size: 14.22px !important;
      margin-bottom: 10px;
      color: var(--site-font-secondary-color) !important;    
    }

    .tooltip-legendtitletext{
      //float: left;
      margin-bottom: 10px;
      font-size: 14.22px !important;
      font-weight: 400 !important;
      color: #828E9A !important;
    }
    .dx-tooltip {
      position: absolute;
      color: rgb(0, 0, 0);
      padding: 10px;
      background: rgb(255, 255, 255);
      border-radius: 3px;
      z-index: 10000;
      flex-direction: column;
      pointer-events: none;
    }

    .dx-tooltip-pipe {
      align-self: center;
      margin-right: 5px;
      width: 20px;
      margin-bottom: 30px;
      height: 20px;
      border-radius: 2px;
      background-color: var(--site-font-chart-color);
      clip-path: circle(30%);
    }
    .regression-marker{
      align-self: center;
      margin-right: 5px;
      width: 15px;
      margin-bottom: 30px;
      height: 3px;
      border-radius: 2px;
      background-color: unset !important;
      background: repeating-linear-gradient(to right, black 0, black 5px, transparent 5px, transparent 7px);
    }

    .dx-tooltip-label {
      display: flex;
      width: 100%;
      justify-content: space-between;
    }
  .wy-panel-column-chart {
    position: relative;
    g.axistext.aa {
      transform: translate(130px, 262px)!important;
    }
    g.yaxislayer-above .ytick text {
      font-size: 0.55vw !important;
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
    }
    g.xaxislayer-above .xtick text{
      font-size: 0.5vw !important;
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
    }
    .legendtext {
      font-size: 0.55vw !important;
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
    }
    
    .hoverlayer {
      display: none;

      .hovertext {
        opacity: 1 !important;
      }
      .axistext text{
        font-size: 12px !important;
      }

      g.axistext text{
        dominant-baseline: text-before-edge;
        // transform: translate(0px, 262px)!important;
      }
    }
    .hoverlayer .line{
      display: block !important;
    }
    .tooltips {
      display: none;
    }
    rect.rangeslider-slidebox {
      cursor: grab !important;
    }
    .cursor-ew-resize, .cursor-w-resize, .cursor-e-resize {
      cursor: default !important;
    }
    rect.rangeslider-mask-min, rect.rangeslider-mask-max {
      fill: #888888 !important;
      fill-opacity: 0.5 !important;
    }
  }

  @media screen and (max-width: 1400px) {
    .wy-panel-column-chart {
      g.yaxislayer-above .ytick text {
        font-size: 0.85vw !important;
      }
      g.xaxislayer-above .xtick text{
        font-size: 0.85vw !important;
      }
      .legendtext {
        font-size: 0.85vw !important;
      }
    }
  }
</style>